import * as categoryApi from './therapeuticCategoryApi';
import * as categoryActions from './therapeuticCategoryActions';

export function getCategoryList() {
  return (dispatch) => {
    categoryApi.getCategoryList().then((response) => {
      if (response && response.status === 200 && response.data) {
        dispatch(categoryActions.setCategoryList(response.data));
      }
    });
  };
}

export function addCategory(category, cb) {
  return (dispatch) => {
    categoryApi.addCategory(category).then((response) => {
      if (response && response.status === 201 && response.data) {
        dispatch(categoryActions.addCategory(response.data));
        cb();
      }
    });
  };
}

export function updateCategory(category, cb) {
  return (dispatch) => {
    categoryApi.updateCategory(category).then((response) => {
      if (response && response.status === 200 && response.data) {
        dispatch(categoryActions.updateCategory(response.data));
        cb();
      }
    });
  };
}

export function deleteCategory(category) {
  return (dispatch) => {
    categoryApi.deleteCategory(category).then((response) => {
      if (response && response.status === 204) {
        dispatch(categoryActions.deleteCategory(category.id));
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/therapeuticCategory/therapeuticCategoryServices.js